import React from 'react';
import { BsGem } from 'react-icons/bs';
import { Pagination } from 'swiper';
import { Autoplay } from "swiper";


import { Swiper, SwiperSlide } from 'swiper/react';

import codecamp from "../../assets/cirtificate.png";
import pHeroCertificate from '../../assets/certificatePHero.png';
import blackbelt from '../../assets/blackbelt.png';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';

import './testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      link: 'https://drive.google.com/file/d/1P1FYCRGheqz97q5dPJBzHsGoq5NupFMm/view?usp=sharing',
      name: 'Complete Web Development',
      institute: 'Programming Hero',
      img: pHeroCertificate,
    },
    {
      id: 2,
      link: 'https://www.freecodecamp.org/certification/asadul-rahman/javascript-algorithms-and-data-structures',
      name: 'JavaScript Algorithms and Data Structures',
      institute: 'freeCodeCamp.org',
      img: codecamp,
    },
    {
      id: 3,
      link: 'https://drive.google.com/file/d/17ra9g2EHp4Gu5HlvjYRNU99L0kSGt4uQ/view?usp=sharing',
      name: 'BLACK BELT',
      institute: 'Programming Hero',
      img: blackbelt,
    }
  ];
  return (
    <section id="testmonials">
      <h5>Some of my achievements</h5>
      <h2>Education/ Certificates</h2>
      <Swiper
        className="container testimonials__container"
        modules={[Autoplay, Pagination]}
        spaceBetween={40}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {testimonials.map((test) => (
          <SwiperSlide className="testimonial" key={test.id}>
            <div className="client__avatar">
              <a href={test.link} target="_blank" rel="noopener noreferrer">
                <BsGem />
              </a>
            </div>
            <a href={test.link} className='client__name' target="_blank" rel="noopener noreferrer">{test.name}</a>
            <p className='institute'>{test.institute}</p>

            <a href={test.link} target="_blank" rel="noopener noreferrer">
              <img className='cert-img' src={test.img} alt="codecamp" />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default Testimonials